const PREFIX = 'UNTERN-BUCHEN: ';
const storagePrefix = (scope?: string) =>
  scope ? `UNTERN-BUCHEN (${scope}): ` : PREFIX;

export type StorageData = { [label: string]: string };

export const readStorage = (scope?: string): StorageData => {
  const prefix = storagePrefix(scope);
  return Object.keys(localStorage)
    .filter(key => key.startsWith(prefix))
    .reduce((storage: StorageData, key: string) => {
      storage[key.slice(prefix.length)] = localStorage.getItem(key) ?? '';
      return storage;
    }, {});
};

export const updateStorage = (newData: StorageData, scope?: string) =>
  Object.keys(newData).forEach(key =>
    localStorage.setItem(`${storagePrefix(scope)}${key}`, newData[key]),
  );

export const removeStorage = (key: string, scope?: string) =>
  localStorage.removeItem(`${storagePrefix(scope)}${key}`);
